import { render, staticRenderFns } from "./DimishedCalculateResult.vue?vue&type=template&id=33b2551c&scoped=true&"
import script from "./DimishedCalculateResult.vue?vue&type=script&lang=js&"
export * from "./DimishedCalculateResult.vue?vue&type=script&lang=js&"
import style0 from "./DimishedCalculateResult.vue?vue&type=style&index=0&id=33b2551c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b2551c",
  null
  
)

export default component.exports